import React, { useEffect, useState } from "react";
import {
  Typography,
  Button,
  Paper,
  IconButton,
  Box,
  Switch,
  TextField,
  FormControl,
  FormLabel,
  Input,
  Autocomplete,
} from "@mui/material";
import Editor from "../../components/EditorTemplate/Editor";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { clearMessage } from "../../redux/Slice/message";
import { setLoading } from "../../redux/Slice/loaderSlice";
import FormFields from "../../components/EditorTemplate/FormFields";
import SaveDialog from "../../components/EditorTemplate/HelperDialog/SaveDialog";
import { createQuote } from "../../redux/Slice/quoteSlice";
import { AddCircle, Check, Edit, RemoveCircle } from "@mui/icons-material";
import { QuoteSchemaDropdown } from "../../utils/data";
import DynamicForm from "../../components/EditorTemplate/DynamicForm";
import Grid from "@mui/material/Grid2"

const CreateTem = () => {

  const location = useLocation();

  const state = location.state;

  console.log(state.service_id);

  const [templateName, setTemplateName] = useState("");
  const [inputSchema, setInputSchema] = useState({ data: {}, system: "" });
  const [ContextSchema, setContextSchema] = useState([]);
  const [outputSchema, setOutputSchema] = useState({ data: {}, system: "" });
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const message = useSelector((state) => state.message);

  // useEffect(() => {
  //   if (message?.message) {
  //     toast(message?.message);
  //     dispatch(clearMessage());
  //   }
  // }, [message, dispatch]);
console.log(ContextSchema);
  useEffect(() => {
    const value = Object.values(inputSchema.data);
    console.log(value);  
    setContextSchema((prev) => {
      const Prevdata=[]
      value.map((data,index) => {
        Prevdata.push({ data: {}, system: "", title: data.placeholder, type: data.type, status: false, isEditable: false })
      });
      return Prevdata
     })
  },[inputSchema])
  const handleSave = () => {
    dispatch(setLoading(true));
    const formData = {
      service_id: state.service_id,
      default: true,
      templateName,
      inputJsonSchema: inputSchema,
      ContextJsonSchema: ContextSchema,
      outpuJsonSchema: outputSchema,
    };

    console.log(formData)

    dispatch(createQuote(formData))
      .unwrap()
      .then(() => {
        dispatch(setLoading(false));
        navigate(-1);
      })
      .catch((error) => {
        dispatch(setLoading(false));
        console.error("Error creating quote:", error);
      })

    setIsDialogOpen(false);
  };

  const addArrayItem = (path, setSchema) => {
    setSchema((prevState) => {
      const keys = path.split(".");
      const newState = { ...prevState };
      let current = newState;

      keys.forEach((key, index) => {
        if (!current[key]) {
          current[key] = isNaN(keys[index + 1]) ? {} : [];
        }
        if (index === keys.length - 1) {
          current[key] = [...(current[key] || []), {}];
        } else {
          current[key] = { ...current[key] };
          current = current[key];
        }
      });

      return newState;
    });
  };

  const removeArrayItem = (path, index, setSchema) => {
    setSchema((prevState) => {
      const keys = path.split(".");
      const newState = { ...prevState };
      let current = newState;

      keys.forEach((key, idx) => {
        if (idx === keys.length - 1 && Array.isArray(current[key])) {
          current[key].splice(index, 1);
        } else {
          current[key] = { ...current[key] };
          current = current[key];
        }
      });

      return newState;
    });
  };

  const handleChange = (path, value, setSchema) => {
    const keys = path.split(".");
    setSchema((prevState) => {
      const newState = { ...prevState };
      let current = newState;

      keys.forEach((key, index) => {
        if (index === keys.length - 1) {
          current[key] = value;
        } else {
          current[key] = { ...current[key] };
          current = current[key];
        }
      });

      return newState;
    });
  };

  const getValue = (path, schema) =>
    path.split(".").reduce((acc, key) => acc?.[key], schema);

  const handleAddContextSchema = () => {
    setContextSchema((prev) => [...prev, {data:{},system:"",title:"",status:false,isEditable:false}]);
  };

  const handleRemoveContextSchema = (index) => {
    setContextSchema((prev) => prev.filter((_, i) => i !== index));
  };

  // const handleSchemaChange = (index, updatedSchema) => {
  //     setContextSchema((prev) => prev.map((schema, i) => (i === index ? updatedSchema : schema)));
  // };

  const handleToggleContextSchema = (index, status) => {
    const updatedSchema = [...ContextSchema];
    updatedSchema[index].status = status;
    setContextSchema(updatedSchema);
  };

  const handleTitleChange = (index, newTitle) => {
    const updatedSchema = [...ContextSchema];
    updatedSchema[index].title = newTitle;
    setContextSchema(updatedSchema);
  };
  const handleSystemRoleChange = (index, value) => {
    const updatedSchema = [...ContextSchema];
    updatedSchema[index].system = value;
    setContextSchema(updatedSchema);
  };

  const handleEditClick = (index) => {
    const updatedSchema = [...ContextSchema];
    updatedSchema[index].isEditable = true;
    setContextSchema(updatedSchema);
  };

  const handleSaveClick = (index) => {
    const updatedSchema = [...ContextSchema];
    updatedSchema[index].isEditable = false;
    setContextSchema(updatedSchema);
  };

  return (
    <>
      <Typography variant="h4" gutterBottom sx={{mx: 2}}>
        Template Creation
      </Typography>
      {/* <Grid
        container
        spacing={2}
        sx={{ padding: 3, border: "1px solid #ddd", borderRadius: 2 }}> */}
        {/* Input Schema */}
        <Grid container spacing={4} sx={{ padding: 2 }}>
          <Grid item size={6} sx={{ padding: 3, border: "1px solid #ddd", borderRadius: 2 }}>

            {/* <Paper elevation={3} sx={{ padding: 3, marginBottom: 2 }}> */}
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                marginBottom={2}>
                <Typography variant="h6">Input Schema</Typography>
              </Box>
              <Editor
                schema={inputSchema.data}
                onChange={(value) =>
                  setInputSchema((prev) => ({ ...prev, data: value }))
                }
              />
            {/* </Paper> */}
          </Grid>

          <Grid item size={6} sx={{ padding: 3, border: "1px solid #ddd", borderRadius: 2 }}>
            {/* <Paper elevation={3} sx={{ padding: 3 }}> */}
              <Typography variant="h6" marginBottom={2}>
                Define Key-Value Pair
              </Typography>
              <DynamicForm schemaString={inputSchema.data} />
            {/* </Paper> */}
          </Grid>
        </Grid>

        {/* Context Schema */}
        <Grid >
          {ContextSchema.map((schema, index) => (
            <Grid container spacing={4} sx={{ padding: 3 }}>
              <Grid item size={6}>
                <Input
                  type="text"
                  placeholder="system Role"
                  sx={{ mb: 3, width: "100%", }}
                  variant="contained"
                  value={schema.system}
                  onChange={(e) =>
                    handleSystemRoleChange(index, e.target.value)
                  }
                />
                <Box
                  key={index}
                  sx={{ padding: 3, marginBottom: 2,border: "1px solid #ddd", borderRadius: 2}}
                  >
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    marginBottom={2}>
                    {/* Editable Title with TextField */}
                    <Grid item size={2}>
                      <FormControl fullWidth>
                        <Box display="flex" alignItems="center" sx={{ gap: 2 }}>
                          <Typography variant="h6" marginBottom={2}>
                            {schema.title}
                          </Typography>
                        </Box>
                      </FormControl>
                    </Grid>
                    {/* Toggle Switch */}
                    <Switch
                      color="primary"
                      checked={schema.status}
                      onChange={(e) =>
                        handleToggleContextSchema(index, e.target.checked)
                      }
                    />
                    <IconButton
                      color="error"
                      onClick={() => handleRemoveContextSchema(index)}>
                      <RemoveCircle />
                    </IconButton>
                  </Box>
                  
                  <Editor
                    schema={schema.data}
                    onChange={(value) =>
                      setContextSchema((prev) => {
                        const updatedSchema = [...prev];
                        updatedSchema[index].data = value;
                        return updatedSchema;
                      })
                    }
                  />
                
                </Box>
              </Grid>

              <Grid item size={6}>
                <Box
                  key={index}
                  sx={{ padding: 3, marginBottom: 2,border: "1px solid #ddd", borderRadius: 2,height:"58vh",mt:7}}>
                  <Typography variant="h6" marginBottom={2}>
                    Define Key-Value Pairs
                  </Typography>
                  <FormFields
                    schema={schema.data}
                    getValue={(path) => getValue(path, ContextSchema)}
                    handleChange={(path, value) =>
                      handleChange(path, value, setContextSchema)
                    }
                    addArrayItem={(path) =>
                      addArrayItem(path, setContextSchema)
                    }
                    removeArrayItem={(path, index) =>
                      removeArrayItem(path, index, setContextSchema)
                    }
                  />
                </Box>
              </Grid>
            </Grid>
          ))}
        </Grid>

        {/* Output Schema */}
        <Grid container spacing={4} sx={{ padding: 3 }}>
          <Grid item size={6} >
            <Input
              type="text"
              placeholder="system Role"
              sx={{ mb: 3, width: "100%" }}
              variant="contained"
              value={outputSchema?.system}
              onChange={(e) =>
                setOutputSchema((prev) => ({ ...prev, system: e.target.value }))
              }
            />
            {/* <Paper elevation={3} sx={{ padding: 3, marginBottom: 2 }}> */}
            
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                marginBottom={2}
                >
                <Typography variant="h6">Output Schema</Typography>
              </Box>
              <Editor
                schema={outputSchema?.data}
                onChange={(value) =>
                  setOutputSchema((prev) => ({ ...prev, data: value }))
                }
              />
            {/* </Paper> */}
          </Grid>

          <Grid item size={6} sx={{mt:2}}>
          <Box sx={{ padding: 3, marginBottom: 2,border: "1px solid #ddd", borderRadius: 2,height:"55vh"}}>              
            <Typography variant="h6" marginBottom={2}>
                Define Key-Value Pairs
              </Typography>
              <FormFields
                schema={outputSchema?.data}
                getValue={(path) => getValue(path, outputSchema?.data)}
                handleChange={(path, value) =>
                  handleChange(path, value, setOutputSchema?.data)
                }
                addArrayItem={(path) =>
                  addArrayItem(path, setOutputSchema?.data)
                }
                removeArrayItem={(path, index) =>
                  removeArrayItem(path, index, setOutputSchema?.data)
                }
              />
            </Box>
          </Grid>
        </Grid>
        <Grid
          sx={{
            justifyContent: "flex-end",
            display: "flex",
            gap: 3,
            mt: 3,
            width: "100%",
          }}>
          <Button
            // variant="contained"
            sx={{ backgroundColor: "#2FB354",
              color: "white",}}
            onClick={() => setIsDialogOpen(true)}>
            Save Quote
          </Button>
        </Grid>
      {/* </Grid> */}

      <SaveDialog
        open={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        templateName={templateName}
        onTemplateNameChange={setTemplateName}
        onSave={handleSave}
      />
    </>
  );
};

export default CreateTem;
